// import React, { useState, useEffect, useContext } from "react";
// import Grid from "@mui/material/Grid";
// import Card from "@mui/material/Card";
// import TextField from "@mui/material/TextField";
// import CircularProgress from "@mui/material/CircularProgress";
// import axios from "axios";

// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
// import Autocomplete from "@mui/material/Autocomplete";

// import MDBox from "components/MDBox";
// import MDButton from "components/MDButton";
// import MDSnackbar from "components/MDSnackbar";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// import { AccountsContext } from "context/AccountsContext";
// import EVReportTable from "./EVReportTable";

// const INTERVAL_OPTIONS = [
//   { label: "None", value: null },
//   { label: "5 min", value: 5 },
//   { label: "10 min", value: 10 },
//   { label: "15 min", value: 15 },
//   { label: "20 min", value: 20 },
//   { label: "25 min", value: 25 },
//   { label: "30 min", value: 30 },
//   { label: "35 min", value: 35 },
//   { label: "40 min", value: 40 },
//   { label: "45 min", value: 45 },
//   { label: "50 min", value: 50 },
//   { label: "55 min", value: 55 },
//   { label: "60 min", value: 60 },
// ];

// function EVReport() {
//   const [reportData, setReportData] = useState([]);
//   const [columns, setColumns] = useState([]);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [successSB, setSuccessSB] = useState(false);
//   const [errorSB, setErrorSB] = useState(false);
//   const [vehicleId, setVehicleId] = useState("");
//   const [intervalMin, setIntervalMin] = useState(null);
//   const [loading, setLoading] = useState(false);
  
//   // Naya state jo binary file ko hold karega
//   const [fileBlob, setFileBlob] = useState(null);

//   const { fetchThings, things } = useContext(AccountsContext);

//   useEffect(() => {
//     fetchThings();
//   }, []);

//   const formatDateTime = (date) => {
//     if (!date) return "";
//     const pad = (n) => String(n).padStart(2, '0');
//     return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
//   };

//   const displayFormat = (dateStr) => {
//     if (!dateStr) return "";
//     const date = new Date(dateStr);
//     return date.toLocaleString('en-US', {
//       month: 'short', day: '2-digit', year: 'numeric',
//       hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true
//     });
//   };

//   const formatHeader = (key) => {
//     return key
//       .replace(/_/g, " ")
//       .replace(/([A-Z])/g, " $1")
//       .trim()
//       .replace(/\b\w/g, (c) => c.toUpperCase());
//   };

//   const [startTime, setStartTime] = useState(new Date(new Date().setHours(0, 0, 0, 0)));
//   const [endTime, setEndTime] = useState(new Date(new Date().setHours(23, 59, 59, 999)));

//   const fetchLogs = async () => {
//     if (!vehicleId) {
//       setErrorMessage("Please select a vehicle");
//       setErrorSB(true);
//       return;
//     }
//     setLoading(true);
//     setErrorMessage("");
//     try {
//       const payload = {
//         thingId: vehicleId,
//         fromDateTime: formatDateTime(startTime),
//         toDateTime: formatDateTime(endTime),
//         ...(intervalMin !== null && {
//           intervalMinutes: intervalMin,
//         }),
//       };
//       const token = localStorage.getItem("token");

//       // Configure axios request
//       const config = {
//         headers: { "x-dhundhoo-session": token, "Content-Type": "application/json" },
//       };

//       // Agar interval null hai, toh expect file from API (binary data)
//       if (intervalMin === null) {
//         config.responseType = 'blob'; 
//       }

//       const response = await axios.post("https://v3.dhundhoo.com/api/evdata/report", payload, config);

//       // Jab binary file (.xlsx) aati hai
//       if (intervalMin === null) {
//         setFileBlob(response.data); // Pure blob ko state me store kar lenge
//         setReportData([]);         
//         setColumns([]);            
//         setSuccessSB(true);
//         setLoading(false);
//         return;                   
//       }

//       // Jab JSON data aata hai (Interval selected)
//       setFileBlob(null); 

//       let data = response.data;
//       let dataArray = [];
//       if (data && data.content && Array.isArray(data.content)) {
//         dataArray = data.content;
//       } else if (Array.isArray(data)) {
//         dataArray = data;
//       } else if (data) {
//         dataArray = [data];
//       }

//       if (!dataArray || dataArray.length === 0 || Object.keys(dataArray[0]).length === 0) {
//         setReportData([]);
//         setColumns([]);
//         setErrorMessage("No data found for this vehicle and time range.");
//         setErrorSB(true);
//       } else {
//         const allKeys = Array.from(new Set(dataArray.reduce((acc, curr) => [...acc, ...Object.keys(curr)], [])));

//         const dynamicColumns = allKeys.map((key) => ({
//           Header: formatHeader(key),
//           accessor: key,
//           width: key.includes("time") || key.includes("date") || key === "updated_at" ? "200px" : "150px"
//         }));

//         const safeRows = dataArray.map((row) => {
//           const formattedRow = {};
//           allKeys.forEach((key) => {
//             let val = row[key];
//             if ((key === "updated_at" || key === "updatedAt") && val) {
//               formattedRow[key] = displayFormat(val);
//             } else if (typeof val === "object" && val !== null) {
//               formattedRow[key] = JSON.stringify(val);
//             } else {
//               formattedRow[key] = val !== null && val !== undefined ? String(val) : "--";
//             }
//           });
//           return formattedRow;
//         });

//         setColumns(dynamicColumns);
//         setReportData(safeRows);
//         setSuccessSB(true);
//       }
//     } catch (error) {
//       console.error(error);
//       setErrorMessage("Failed to fetch EV data from API.");
//       setErrorSB(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const exportToCSV = () => {
//     // Agar API ne binary file (Blob) bheji hai
//     if (fileBlob) {
//       const url = window.URL.createObjectURL(fileBlob);
//       const link = document.createElement("a");
//       link.href = url;
//       // Ab extension ko .xlsx kar diya gaya hai kyunki data format Excel ka hai
//       link.download = `EV_Report_${new Date().toISOString().split("T")[0]}.xlsx`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
//       return; 
//     }

//     // Interval wale JSON response ke liye normal CSV export
//     if (reportData.length === 0 || columns.length === 0) return;

//     const headers = columns.map(col => col.Header).join(",");
//     const rows = reportData.map(row =>
//       columns.map(col => {
//         let val = row[col.accessor] ?? "";
//         return `"${val}"`;
//       }).join(",")
//     ).join("\n");

//     const csvData = "\ufeff" + headers + "\n" + rows;
//     const blob = new Blob([csvData], {
//       type: "text/csv;charset=utf-8;"
//     });

//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = `EV_Report_${new Date().toISOString().split("T")[0]}.csv`;
//     link.click();
//   };

//   const handleClear = () => {
//     setVehicleId("");
//     setIntervalMin(null);
//     setStartTime(new Date(new Date().setHours(0, 0, 0, 0)));
//     setEndTime(new Date(new Date().setHours(23, 59, 59, 999)));
//     setReportData([]);
//     setColumns([]);
//     setFileBlob(null); 
//     setErrorMessage("");
//   };

//   return (
//     <DashboardLayout>
//       <DashboardNavbar />
//       <MDBox pt={6} pb={3}>
//         <Grid container spacing={6}>
//           <Grid item xs={12}>
//             <Card>
//               <MDBox p={3} pb={0}>
//                 <LocalizationProvider dateAdapter={AdapterDateFns}>
//                   <Grid container spacing={2} alignItems="center">
//                     <Grid item xs={12} sm={6} md={2.4}>
//                       <Autocomplete
//                         options={things || []}
//                         getOptionLabel={(option) => option.thingId || ""}
//                         value={things.find((t) => t.thingId === vehicleId) || null}
//                         onChange={(e, nv) => setVehicleId(nv ? nv.thingId : "")}
//                         renderInput={(params) => <TextField {...params} label="Select Vehicle" fullWidth size="small" />}
//                       />
//                     </Grid>
//                     <Grid item xs={12} sm={6} md={2.4}>
//                       <Autocomplete
//                         options={INTERVAL_OPTIONS}
//                         getOptionLabel={(option) => option.label}
//                         isOptionEqualToValue={(option, value) => option.value === value.value}
//                         value={INTERVAL_OPTIONS.find((o) => o.value === intervalMin) || INTERVAL_OPTIONS[0]}
//                         onChange={(e, nv) => setIntervalMin(nv ? nv.value : null)}
//                         renderInput={(params) => <TextField {...params} label="Interval" fullWidth size="small" />}
//                       />
//                     </Grid>
//                     <Grid item xs={12} sm={6} md={2.4}>
//                       <DateTimePicker ampm={false} label="Start Date/Time" value={startTime} onChange={setStartTime} renderInput={(params) => <TextField {...params} fullWidth size="small" />} />
//                     </Grid>
//                     <Grid item xs={12} sm={6} md={2.4}>
//                       <DateTimePicker ampm={false} label="End Date/Time" value={endTime} onChange={setEndTime} renderInput={(params) => <TextField {...params} fullWidth size="small" />} />
//                     </Grid>
//                     <Grid item xs={12} md={2.4} display="flex" gap={1}>
//                       <MDButton variant="gradient" color="info" size="small" onClick={fetchLogs} disabled={loading} fullWidth>LOAD</MDButton>
//                       <MDButton variant="outlined" color="error" size="small" onClick={handleClear} disabled={loading} fullWidth>CLEAR</MDButton>
//                       <MDButton variant="gradient" color="secondary" size="small" onClick={exportToCSV} disabled={loading || (reportData.length === 0 && !fileBlob)} fullWidth>DOWNLOAD</MDButton>
//                     </Grid>
//                   </Grid>
//                 </LocalizationProvider>
//               </MDBox>

//               <MDBox pt={3} px={2} pb={2}>
//                 {loading ? (
//                   <MDBox display="flex" justifyContent="center" p={5}><CircularProgress /></MDBox>
//                 ) : reportData.length > 0 && columns.length > 0 ? (
//                   <EVReportTable
//                     table={{ columns, rows: reportData }}
//                     showTotalEntries={true}
//                     isSorted={true}
//                     noEndBorder
//                   />
//                 ) : fileBlob && !loading ? (
//                   <MDBox display="flex" justifyContent="center" p={5}>
//                     <i>Excel data loaded successfully. Please click the DOWNLOAD button to save.</i>
//                   </MDBox>
//                 ) : null}
//               </MDBox>
//             </Card>
//           </Grid>
//         </Grid>
//       </MDBox>
//       <MDSnackbar color="success" icon="check" title="EV Report" content="Data Loaded Successfully" open={successSB} onClose={() => setSuccessSB(false)} />
//       <MDSnackbar color="error" icon="warning" title="EV Report" content={errorMessage} open={errorSB} onClose={() => setErrorSB(false)} />
//     </DashboardLayout>
//   );
// }

// export default EVReport;

import React, { useState, useEffect, useContext } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Autocomplete from "@mui/material/Autocomplete";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DownloadExcelButton from "components/ReportUI/Downloadexcelbutton";
import MDSnackbar from "components/MDSnackbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { AccountsContext } from "context/AccountsContext";
import EVReportTable from "./EVReportTable";
import DateRangePicker from "layouts/DateTimerange/dateTimeRange"; // ✅ Custom Range Picker (same as all other reports)
import DhundhooLoader from "../Loader/Loader";

const INTERVAL_OPTIONS = [
  { label: "None", value: null },
  { label: "5 min", value: 5 },
  { label: "10 min", value: 10 },
  { label: "15 min", value: 15 },
  { label: "20 min", value: 20 },
  { label: "25 min", value: 25 },
  { label: "30 min", value: 30 },
  { label: "35 min", value: 35 },
  { label: "40 min", value: 40 },
  { label: "45 min", value: 45 },
  { label: "50 min", value: 50 },
  { label: "55 min", value: 55 },
  { label: "60 min", value: 60 },
];

function EVReport() {
  const [reportData, setReportData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const [vehicleId, setVehicleId] = useState("");
  const [intervalMin, setIntervalMin] = useState(null);
  const [loading, setLoading] = useState(false);

  // Naya state jo binary file ko hold karega
  const [fileBlob, setFileBlob] = useState(null);

  const { fetchThings, things } = useContext(AccountsContext);

  useEffect(() => {
    fetchThings();
  }, []);

  // ✅ Same "YYYY-MM-DD" helper used across all reports
  const getTodayDateString = () => {
    const today = new Date();
    const y = today.getFullYear();
    const m = String(today.getMonth() + 1).padStart(2, "0");
    const d = String(today.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };

  const todayStr = getTodayDateString();
  const defaultStart = `${todayStr}T00:00`;
  const defaultEnd = `${todayStr}T23:59`;

  // ✅ Custom DateRangePicker works with "YYYY-MM-DDTHH:mm" strings
  const [startTime, setStartTime] = useState(defaultStart);
  const [endTime, setEndTime] = useState(defaultEnd);

  // ✅ Converts the picker's "YYYY-MM-DDTHH:mm" value into "YYYY-MM-DD HH:mm:ss" for the API
  const formatDateTime = (dateTimeStr) => {
    if (!dateTimeStr) return "";
    const [datePart, timePart] = dateTimeStr.split("T");
    return `${datePart} ${timePart ? `${timePart}:00` : "00:00:00"}`;
  };

  // Table display format for the "updated_at" style columns coming back from the API
  const displayFormat = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  const formatHeader = (key) => {
    return key
      .replace(/_/g, " ")
      .replace(/([A-Z])/g, " $1")
      .trim()
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);

  const fetchLogs = async () => {
    if (!vehicleId) {
      setErrorMessage("Please select a vehicle.");
      openErrorSB();
      return;
    }

    if (!startTime || !endTime) {
      setErrorMessage("Please select a date range first.");
      openErrorSB();
      return;
    }

    setLoading(true);
    setErrorMessage("");
    try {
      const payload = {
        thingId: vehicleId,
        fromDateTime: formatDateTime(startTime),
        toDateTime: formatDateTime(endTime),
        ...(intervalMin !== null && {
          intervalMinutes: intervalMin,
        }),
      };
      const token = localStorage.getItem("token");

      // Configure axios request
      const config = {
        headers: { "x-dhundhoo-session": token, "Content-Type": "application/json" },
      };

      // Agar interval null hai, toh expect file from API (binary data)
      if (intervalMin === null) {
        config.responseType = "blob";
      }

      const response = await axios.post("https://v3.dhundhoo.com/api/evdata/report", payload, config);

      // Jab binary file (.xlsx) aati hai
      if (intervalMin === null) {
        setFileBlob(response.data); // Pure blob ko state me store kar lenge
        setReportData([]);
        setColumns([]);
        openSuccessSB();
        setLoading(false);
        return;
      }

      // Jab JSON data aata hai (Interval selected)
      setFileBlob(null);

      let data = response.data;
      let dataArray = [];
      if (data && data.content && Array.isArray(data.content)) {
        dataArray = data.content;
      } else if (Array.isArray(data)) {
        dataArray = data;
      } else if (data) {
        dataArray = [data];
      }

      if (!dataArray || dataArray.length === 0 || Object.keys(dataArray[0]).length === 0) {
        setReportData([]);
        setColumns([]);
        setErrorMessage("No data found for this vehicle and time range.");
        openErrorSB();
      } else {
        const allKeys = Array.from(new Set(dataArray.reduce((acc, curr) => [...acc, ...Object.keys(curr)], [])));

        const dynamicColumns = allKeys.map((key) => ({
          Header: formatHeader(key),
          accessor: key,
          width: key.includes("time") || key.includes("date") || key === "updated_at" ? "200px" : "150px",
        }));

        const safeRows = dataArray.map((row) => {
          const formattedRow = {};
          allKeys.forEach((key) => {
            let val = row[key];
            if ((key === "updated_at" || key === "updatedAt") && val) {
              formattedRow[key] = displayFormat(val);
            } else if (typeof val === "object" && val !== null) {
              formattedRow[key] = JSON.stringify(val);
            } else {
              formattedRow[key] = val !== null && val !== undefined ? String(val) : "--";
            }
          });
          return formattedRow;
        });

        setColumns(dynamicColumns);
        setReportData(safeRows);
        openSuccessSB();
      }
    } catch (error) {
      console.error(error);
      setErrorMessage("Failed to fetch EV data from API.");
      openErrorSB();
    } finally {
      setLoading(false);
    }
  };

  const exportToCSV = () => {
    // Agar API ne binary file (Blob) bheji hai
    if (fileBlob) {
      const url = window.URL.createObjectURL(fileBlob);
      const link = document.createElement("a");
      link.href = url;
      // Ab extension ko .xlsx kar diya gaya hai kyunki data format Excel ka hai
      link.download = `EV_Report_${new Date().toISOString().split("T")[0]}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      return;
    }

    // Interval wale JSON response ke liye normal CSV export
    if (reportData.length === 0 || columns.length === 0) {
      setErrorMessage("No data to export");
      openErrorSB();
      return;
    }

    const formatFileDate = (dateTime) => {
      if (!dateTime) return "";
      const date = new Date(dateTime);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    const formattedDate = `${formatFileDate(startTime)}_to_${formatFileDate(endTime)}`;

    const headers = columns.map((col) => col.Header).join(",");
    const rows = reportData
      .map((row) =>
        columns
          .map((col) => {
            let val = row[col.accessor] ?? "";
            return `"${val}"`;
          })
          .join(",")
      )
      .join("\n");

    const csvData = "\ufeff" + headers + "\n" + rows;
    const blob = new Blob([csvData], {
      type: "text/csv;charset=utf-8;",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `EV_Report_${formattedDate}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleClear = () => {
    setVehicleId("");
    setIntervalMin(null);
    setStartTime(defaultStart);
    setEndTime(defaultEnd);
    setReportData([]);
    setColumns([]);
    setFileBlob(null);
    setErrorMessage("");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox p={3} pb={0}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={6} md={2.4}>
                      <Autocomplete
                        disablePortal
                        options={things || []}
                        getOptionLabel={(option) => option.thingId || ""}
                        value={things?.find((t) => t.thingId === vehicleId) || null}
                        onChange={(event, newValue) => {
                          setVehicleId(newValue ? newValue.thingId : "");
                        }}
                        renderOption={(props, option) => (
                          <li
                            {...props}
                            key={option.thingId}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <span>{option.nickName}</span>
                            <span style={{ color: "#666" }}>{option.thingId}</span>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Search or add vehicle number"
                            fullWidth
                            size="small"
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#FB8C00",
                                },
                              },
                              "& .MuiInputLabel-root.Mui-focused": {
                                color: "#FB8C00",
                              },
                            }}
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>
                      <Autocomplete
                        disableClearable
                        options={INTERVAL_OPTIONS}
                        getOptionLabel={(option) => option.label}
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                        value={INTERVAL_OPTIONS.find((o) => o.value === intervalMin) || INTERVAL_OPTIONS[0]}
                        onChange={(e, nv) => setIntervalMin(nv ? nv.value : null)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Interval"
                            fullWidth
                            size="small"
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#FB8C00",
                                },
                              },
                              "& .MuiInputLabel-root.Mui-focused": {
                                color: "#FB8C00",
                              },
                            }}
                          />
                        )}
                      />
                    </Grid>

                    {/* ✅ Same custom DateRangePicker used across all other reports */}
                    <Grid item xs={12} md={4.6}>
                      <div style={{ width: "70%" }}>
                        <DateRangePicker
                          startTime={startTime}
                          endTime={endTime}
                          onChange={({ startTime: s, endTime: e }) => {
                            setStartTime(s);
                            setEndTime(e);
                          }}
                          disabled={loading}
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <Grid container spacing={1}>
                        <Grid item xs={4}>
                          <MDButton
                            fullWidth
                            variant="gradient"
                            color="warning"
                            size="small"
                            onClick={fetchLogs}
                            disabled={loading}
                          >
                            {loading ? <CircularProgress size={15} color="inherit" /> : "LOAD"}
                          </MDButton>
                        </Grid>
                        <Grid item xs={4}>
                          <MDButton
                            fullWidth
                            variant="outlined"
                            color="error"
                            size="small"
                            onClick={handleClear}
                            disabled={loading}
                          >
                            CLEAR
                          </MDButton>
                        </Grid>
                        <Grid item xs={4}>
                          <DownloadExcelButton
                            fullWidth
                            label="CSV"
                            onClick={exportToCSV}
                            disabled={loading || (reportData.length === 0 && !fileBlob)}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </LocalizationProvider>
              </MDBox>

              {errorMessage && (
                <MDBox px={2} pt={2}>
                  <Alert severity="error" onClose={() => setErrorMessage("")}>
                    {errorMessage}
                  </Alert>
                </MDBox>
              )}

              <MDBox pt={3} display="flex" justifyContent="center" width="100%">
                {loading ? (
                  <DhundhooLoader />
                ) : reportData.length > 0 && columns.length > 0 ? (
                  <EVReportTable
                    table={{ columns, rows: reportData }}
                    showTotalEntries={true}
                    isSorted={true}
                    noEndBorder
                  />
                ) : fileBlob ? (
                  <MDBox display="flex" justifyContent="center" p={5}>
                    <i>Excel data loaded successfully. Please click the CSV button to download.</i>
                  </MDBox>
                ) : null}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <MDSnackbar
        color="success"
        icon="check"
        title="EV Report"
        content="Data Loaded Successfully"
        open={successSB}
        onClose={closeSuccessSB}
        close={closeSuccessSB}
        bgWhite
      />
      <MDSnackbar
        color="error"
        icon="warning"
        title="EV Report"
        content={errorMessage || "Failed to load report."}
        open={errorSB}
        onClose={closeErrorSB}
        close={closeErrorSB}
        bgWhite
      />
    </DashboardLayout>
  );
}

export default EVReport;